import { useTranslation } from 'react-i18next';
import { Skeleton } from '@/components/ui/skeleton';
import type { EqmsUpdateRequest } from '../../../types/eqms.types';
import { UpdateRequestCard } from './UpdateRequestCard';

interface DocumentUpdateRequestsProps {
  isOwner: boolean;
  requests: EqmsUpdateRequest[] | undefined;
  isLoading: boolean;
  error?: Error | null;
}

/** Owners see and decide every request; anyone else only follows their own. */
export function DocumentUpdateRequests({ isOwner, requests, isLoading, error }: DocumentUpdateRequestsProps) {
  const { t } = useTranslation('qms');
  if (isLoading) return <Skeleton className="h-24 w-full" />;
  if (error) return <p role="alert" className="text-sm text-red-700">{error.message}</p>;
  return (
    <div className="space-y-3">
      {!isOwner && (
        <div>
          <h3 className="text-sm font-medium text-slate-900">{t('updateRequests.documentMine')}</h3>
          <p className="text-xs text-slate-500">{t('updateRequests.documentOwnerOnly')}</p>
        </div>
      )}
      {requests?.length
        ? requests.map((request) => <UpdateRequestCard key={request.id} request={request} mode={isOwner ? 'owner' : 'requester'} />)
        : <p className="py-6 text-center text-sm text-slate-500">{isOwner ? t('updateRequests.emptyFilter') : t('updateRequests.mineEmpty')}</p>}
    </div>
  );
}
